module.exports = __webpack_public_path__ + "img/vip.35a18857.png";